// extracted by mini-css-extract-plugin
export default {"chatBottom":"chatBottom_chatBottom__Lb5JK","ar":"chatBottom_ar__beUzt","chatBottom__imagePreview":"chatBottom_chatBottom__imagePreview__qFCnI","show":"chatBottom_show__rXWrY"};